// src/charts/UniversalChart.jsx
import React from "react";
import MetricCard from "./charts/MetricCard";

import BarViz from "./charts/BarChart";
import CustomAreaChart from "./charts/AreaChart";
import { Typography } from "antd";

/**
 * UniversalChart
 * - type: 'metric' | 'line' | 'bar'
 * - data: canonical [{ x, y, y1?, y2? }]
 * - Intelligent defaults for line grids, legend, height, colors
 */
export default function UniversalChart({
  type = "line",
  subType = "area",

  data = [],

  // metric props
  title,
  subtitle,
  value,
  seriesKey,
  formatter,

  // chart props (line & bar)
  seriesKeys,
  colors,
  height,
  xFormatter,
  yFormatter,
  showGrid,
  showLegend,
  markHighest=false,
  valueMapping={},

  style = {},
}) {
  /* ----------------------------
      DEFAULTS CENTRALIZED HERE
  -----------------------------*/

  const defaultColors = ["#3b82f6", "#10b981", "#f97316", "#8b5cf6"];

  const resolvedHeight = height ?? (type === "metric" ? 88 : 200); // metric=88 line/bar=260

  const resolvedColors = colors ?? defaultColors;

  const resolvedShowGrid = showGrid ?? true;
  const resolvedShowLegend = showLegend ?? true;

  const resolvedXFormatter = xFormatter ?? ((x) => x);
  const resolvedYFormatter = yFormatter ?? ((v) => v);

  /* ----------------------------
            METRIC
  -----------------------------*/
  if (type === "metric") {
    return (
      <MetricCard
        title={title}
        subTitle={subtitle}
        displayValue={value}
        chartType={subType}
        chartData={data}
        seriesMap={seriesKey}
        markHighest={true}
        style={style}
        valueMapping={valueMapping}


      />
    );
  }

  /* ----------------------------
             BAR
  -----------------------------*/
  if (type === "bar") {
    return (
      <BarViz
        data={data}
        seriesKeys={seriesKeys}
        colors={resolvedColors}
        height={resolvedHeight}
        xFormatter={resolvedXFormatter}
        yFormatter={resolvedYFormatter}
        showGrid={resolvedShowGrid}
        showLegend={resolvedShowLegend}
      />
    );
  }

    if (type === "area") {
    return (
      <>

      <Typography.Text strong>{title}</Typography.Text>
      <CustomAreaChart
        chartData={data}
        seriesMap={seriesKeys}
        compact={false}
        style={style}
      />
      </>

    );
  }



  /* ----------------------------
             LINE (default)
  -----------------------------*/
  return (
    <></>
  );
}
